import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { customerApi } from '../api/customerApi';
import { ToastMessage } from '../components/ToastMessage';
import { CustomerUpdateParams } from '../types/customer';

export const useCustomerProfileForm = () => {
  const queryClient = useQueryClient();

  const onSuccess = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: ['customer'] });
    queryClient.invalidateQueries({ queryKey: ['users'] });
    ToastMessage({
      content: `Dado atualizado com sucesso`,
      type: 'success',
    });
  }, [queryClient]);

  const { mutateAsync: updateCustomerData } = useMutation({
    mutationFn: customerApi.updateCustomer,
    onSuccess,
  });

  const handleUpdateCustomer = async (
    params: CustomerUpdateParams,
    changedField: string
  ) => {
    try {
      ToastMessage({
        content: `Atualizando ${changedField.toLocaleLowerCase()} do cliente`,
        type: 'loading',
      });
      updateCustomerData(params);
    } catch (error) {
      ToastMessage({
        content: `Houve um erro ao atualizar o ${changedField.toLocaleLowerCase()}`,
        type: 'error',
      });
    }
  };

  return {
    handleUpdateCustomer,
  };
};
